import { Capacitor } from '@capacitor/core';

const trimSlash = (s: string) => s.replace(/\/+$/, '');

export const env = {
  apiUrl: trimSlash(import.meta.env.VITE_API_URL ?? 'http://localhost:3000'),
  tenantSlug: import.meta.env.VITE_DEFAULT_TENANT_SLUG ?? 'tuconductorrd',
  googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_BROWSER_KEY || '',
  googleMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '',
  /** Estilos de mapa gratuitos (OpenFreeMap) o de un servidor de teselas propio. */
  mapStyle: import.meta.env.VITE_MAP_STYLE_URL || 'https://tiles.openfreemap.org/styles/positron',
  mapStyleDark: import.meta.env.VITE_MAP_STYLE_DARK_URL || 'https://tiles.openfreemap.org/styles/dark',
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
  whatsappNumber: import.meta.env.VITE_WHATSAPP_NUMBER || '',
  isNative: Capacitor.isNativePlatform(),
  platform: Capacitor.getPlatform() as 'web' | 'android' | 'ios',
};

export const apiBase = `${env.apiUrl}/api/v1`;
